/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadsControllerCreateMutationResponse, ThreadsControllerCreate400, ThreadsControllerCreate401, ThreadsControllerCreate403 } from "../../models/threadsController/ThreadsControllerCreate";

function getThreadsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/threads` as const }  
  return res
}

/**
 * @description Manually create a new conversation thread. Note: threads are also auto-created when sending messages without a threadId.
 * @summary Create a new thread
 * {@link /api/v1/threads}
 */
export async function threadsControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ThreadsControllerCreateMutationResponse, ResponseErrorConfig<ThreadsControllerCreate400 | ThreadsControllerCreate401 | ThreadsControllerCreate403>, unknown>({ method : "POST", url : getThreadsControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}